import { render, staticRenderFns } from "./configureAccessControl.vue?vue&type=template&id=7cb7990c&scoped=true&lang=en&"
import script from "./configureAccessControl.vue?vue&type=script&lang=js&"
export * from "./configureAccessControl.vue?vue&type=script&lang=js&"
import style0 from "./configureAccessControl.vue?vue&type=style&index=0&id=7cb7990c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cb7990c",
  null
  
)

export default component.exports